var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#localizationModal",
          },
          on: {
            click: function ($event) {
              return _vm.localizationModal({ action: "add" })
            },
          },
        },
        [_vm._v(" 新增 ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: { rows: _vm.rows, columns: _vm.columns, config: _vm.config },
            scopedSlots: _vm._u([
              {
                key: "Sort",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "text-center" }, [
                      scope.row.vbt_id !== 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              staticStyle: { margin: "0 2px" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort({
                                    guid: scope.row.LocalizationTypeGuid,
                                    action: "up",
                                  })
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-up",
                              }),
                            ]
                          )
                        : _vm._e(),
                      scope.row.vbt_id !== _vm.rows.length
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              staticStyle: { margin: "0 2px" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort({
                                    guid: scope.row.LocalizationTypeGuid,
                                    action: "down",
                                  })
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-down",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "IsEnabled",
                fn: function (props) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#808080",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeEnable(props.row)
                        },
                      },
                      model: {
                        value: props.row.IsEnabled,
                        callback: function ($$v) {
                          _vm.$set(props.row, "IsEnabled", $$v)
                        },
                        expression: "props.row.IsEnabled",
                      },
                    }),
                  ]
                },
              },
              {
                key: "Edit",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#localizationModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.localizationModal({
                              action: "edit",
                              data: props.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "localizationModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "localization",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            _vm.action === "add"
                              ? _c("span", [_vm._v("新增語系")])
                              : _c("span", [_vm._v("編輯語系")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "input-localization-name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" 語系名稱 "),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.language
                                                      .LocalizationTypeName,
                                                  expression:
                                                    "language.LocalizationTypeName",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "input-localization-name",
                                                maxlength: "50",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.language
                                                    .LocalizationTypeName,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.language,
                                                    "LocalizationTypeName",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: _vm.i18n("Position.PositionName"),
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "input-localization-code",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" 語系代號 "),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.language
                                                      .LocalizationTypeCode,
                                                  expression:
                                                    "language.LocalizationTypeCode",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "input-localization-code",
                                                maxlength: "10",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.language
                                                    .LocalizationTypeCode,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.language,
                                                    "LocalizationTypeCode",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.saveLocalization)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }